goog.provide('el8.app.shared.dialog.linkOrder');

goog.require('el8.appservice.notifier');
goog.require('el8.template.app.shared.dialog.linkOrder');
goog.require('el8.template.render.docMgr.filer');
goog.require('el8.service.tz');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.app.shared.dialog.filerFields');

//
// Simple dialog to link an outstanding order to a report -- BiDiLabs
//
el8.app.shared.dialog.linkOrder = (function() {
    var callbackFn = null;
    var reportId = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Link to Outstanding Order',
        height: 400,
        width: 500,
        autoHeight: true,
        contentFn: function() {
            return el8.template.app.shared.dialog.linkOrder.content({});
        }
    });

    var fields = [{
        name: 'orderToLink',
        selector: ':input[name="orderToLink"]'
    }];

    var form = new el8.uiwidget.Form({
        fields: fields
    });

    form.addButton('save', 'Link to Order', saveFn, true);
    form.addCancelButton(function() { that.hide(); });
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        callbackFn = spec.callbackFn || null;
        reportId = spec.reportId || null;

        var $container = $("select[name='orderToLink']", that.getContentElt());
        $.el8_ajax({
            type: 'GET',
            async: false,
            url: '/patient/'+el8.ptdata.currPatient.getId()+'/orders/outstanding/',
            success: function(data) {
                if (data) {
                    var orderMaps = el8.app.shared.dialog.filerFields.outstandingOrdersForDisplay(data);
                    $container.html(el8.template.render.docMgr.filer.outstandingOrders({orders: orderMaps}));
                }
            }
        });
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        callbackFn = null;
        reportId = null;
    };

    function saveFn() {
        if (!form.isValid()) { return; }
        el8.appservice.notifier.notify('Linking report to order');
        var map = form.getMapped();
        var eSet = el8.ptdata.getEntitySet(el8.model.idToModelClass(map.orderToLink));
        var order = eSet.getById(map.orderToLink);

        order.fulfill({
            resolvingDocumentId: reportId,
            successCb: function() {
                el8.ptdata.refreshDocById(this.resolvingDocumentId);
            }
        });
        that.hide();
    }

    return that;

})();

